import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multiselect-dropdown',
  templateUrl: './multiselect-dropdown.component.html',
  styleUrls: ['./multiselect-dropdown.component.css'],
  providers: [NgbDropdownConfig]
})
export class MultiselectDropdownComponent implements OnInit {
  @Input() catalog: string[];
  @Input() idProp: string;
  @Input() textProp: string;
  @Input() singleSelect: boolean;
  @Input() canSelectAll: boolean;
  @Input() selected: string[] = [];
  @Input() searchString: string = '';
  @Input() returnObjectOrigen: boolean;
  @Input() disabled: number = 0;
  @Output() selectedEmitter = new EventEmitter<string[]>();
  @Output() selectValEmitter = new EventEmitter<string[]>();

  @ViewChild("myInput", { static: false }) myInput: ElementRef;

  // estado
  public closed: boolean = true;
  //public selected:string[]=[];
  //public searchString:string='';

  ////////////////
  constructor(config: NgbDropdownConfig) {
    config.placement = 'bottom-left';
    config.autoClose = false;
  }


  ngOnInit() {
  }

  label() {
    return this.selected.length === 0 ? 'Seleccione' : this.catalog.filter(it => this.selected.indexOf(it[this.idProp]) >= 0).map(it => it[this.textProp]).join(', ');
  }

  text = item => item[this.textProp];

  isSelected = item => this.selected.indexOf(item[this.idProp]) >= 0;

  select(e, item) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.singleSelect) {
      this.selected = [];
      this.selected.push(item[this.idProp]);
      this.showSelected();
      // this.selectValEmitter.emit(this.selected);
    } else {
      if (this.isSelected(item)) {
        this.selected = this.selected.filter(it => it !== item[this.idProp]);
      } else {
        this.selected.push(item[this.idProp]);
      }
      this.selectValEmitter.emit(this.selected);
    }
  }

  selectAll(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.searchString = '';
    this.selected = [];
    this.catalog.forEach((item) => {
      this.selected.push(item[this.idProp]);
    });
  }

  selectNone(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.searchString = '';
    this.selected = [];
  }

  showSelected() {
    this.searchString = '';
    this.closed = !this.closed;

    // ← No emitir si no hay nada seleccionado
    if (this.selected.length === 0) {
        this.myInput.nativeElement.focus();
        return;
    }

    if (this.returnObjectOrigen) {
      //console.log(">> 1");
      let selectedObject: any = this.catalog.filter(it => this.selected.includes(it[this.idProp]));
      if (this.closed) {
        //console.log(">> 2");
        this.selectedEmitter.emit(selectedObject);
      }
    } else {
      //console.log(">> 3");
      if (this.closed) {
        //console.log(">> 3");
        this.selectedEmitter.emit(this.selected);
      }
    }
    this.myInput.nativeElement.focus();
  }
}
